exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".emotion img{width:35px;cursor:pointer;transition:all .4s;margin:4px}.emotion{position:relative}.emotion.active img{-webkit-transform:scale(1.1);transform:scale(1.1)}.rate{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.text-baloon{position:absolute;top:-61px;left:0}.text-baloon .content{display:-webkit-box;display:-ms-flexbox;display:flex;padding:3px}.text-baloon .content button{margin:0}.text-baloon .content input{height:100%;padding:12px;margin:2px;width:300px;max-width:100%;border:0}.text-baloon{text-align:center;padding:0;background:#fff;border-radius:2px;box-shadow:0 1px 6px 0 rgba(0,0,0,.12),0 1px 6px 0 rgba(0,0,0,.12)}.text-baloon:after{content:\"\";position:absolute;border-style:solid;border-width:15px 15px 0;border-color:#fff transparent;display:block;width:0;z-index:1;bottom:-10px;left:7px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/game-elements/rating/rating.component.css
// module id = 453
// module chunks = 1